import React, { useState } from 'react'; 
import { useHistory } from 'react-router-dom';
import { useUserContext } from '../../hooks/UserSettingProvider';
import { PATH } from '../../routes/Routes';  
import ConfirmModal from './ConfirmModal';

const ConfirmModalLogout = ({ open, onClose }) => {
  const [visible, setVisible] = useState(open);  
  const history = useHistory();
  const { onLogout } = useUserContext();

  const confirmLogout = () => {
    setVisible(false);  
    onLogout();  
    history.replace(PATH.LOGIN);   
  };

   
  React.useEffect(() => {
    setVisible(open);
  }, [open]);

  return (
     <>
        <ConfirmModal
          open={visible}
          onClose={onClose}
          title= ' ยืนยันการออกจากระบบ' 
          content="คุณต้องการออกจากระบบหรือไม่?"
          onConfirm={confirmLogout}
        /> 
      </> 
  );
};

export default ConfirmModalLogout;
